@let state = footerState();

@let year = state.year;
@let appVersion = state.appVersion;
@let legalLinks = state.legalLinks;
@let supportedLanguages = state.supportedLanguages;
@let currentLanguage = state.currentLanguage;

<footer class="footer border-color-default bg-white border-top-1">
  <div class="container">
    <div class="flex flex-column flex-column-reverse gap-4 text-sm p-y-6 md:flex-row md:justify-content-between">
      <div class="flex flex-column gap-3 font-semibold md:flex-row">
        <div class="flex align-items-center gap-1">
          <i class="las la-copyright line-height-2"></i>

          <span class="m-x">{{ year }}</span>

          <div
            class="footer__title"
            data-nested-translation="footer.title"
            [appRichText]="'footer.title' | translate | hideTranslation | wysiwyg"
          ></div>
        </div>

        @if (legalLinks.length > 0) {
          <div class="footer__legal-links flex flex-wrap align-items-center gap-2">
            @for (legalLink of legalLinks; track legalLink.key) {
              <a
                class="text-sm"
                target="_blank"
                rel="noopener noreferrer"
                [attr.data-translation]="'footer.legal-links.' + legalLink.key"
                [href]="legalLink.url"
              >
                {{ 'footer.legal-links.' + legalLink.key | translate }}
              </a>
            }
          </div>
        }

        @if (appVersion) {
          <span class="footer__version font-medium md:align-self-center">{{ appVersion }}</span>
        }
      </div>

      <app-change-language-dropdown
        [languages]="supportedLanguages"
        [currentLanguage]="currentLanguage"
        (changeLanguageEvent)="onChangeLanguage($event)"
      />
    </div>
  </div>
</footer>
